import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { useDispatch, useSelector } from "react-redux"

import { apiSlice } from "@/shared/api"
import { usageAnalyticsMiddleware } from "@/shared/lib/usage-analytics"
import { rtkErrorMiddleware } from "@/shared/redux"

import { rootReducer } from "./root-reducer"

import type { TypedUseSelectorHook } from "react-redux"

/**
 * Redux store configuration
 */
export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware).concat(rtkErrorMiddleware).concat(usageAnalyticsMiddleware)
})

setupListeners(store.dispatch)

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed hooks
export const useAppDispatch = useDispatch<AppDispatch>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
